import Instance from '../../../../Axios';

// New Actions for the app

const GetMateriais = () => async (dispatch) => {
  await Instance()
    .get(`/energias/tiposMateriais`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_ENERGIAS_MATERIAIS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetMateriais;
